import { profilePhoneSelector } from '@app/store/selectors/profile'
import { createThunk } from '@app/store/thunk'

import { assertMountPush } from '@app/components/Mount/actions'

/**
 * @param _syncHash Used to ensure that profile is updated before calling the action
 */
export function requirePhone(_syncHash: string) {
  return createThunk<Promise<boolean>>(async (dispatch, getState) => {
    const phone = profilePhoneSelector(getState())
    if (phone) return true

    const { promise, resolve } = Promise.withResolvers<boolean>()
    await dispatch(
      assertMountPush(
        import('@app/components/Phone').then(m => m.Phone),
        { props: { callback: resolve } }
      )
    )
    return promise
  })
}
